import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

interface PrescriptionEmptyStateProps {
  primaryText: React.ReactNode;
  secondaryText?: string;
}

export const PrescriptionEmptyState = ({ primaryText, secondaryText }: PrescriptionEmptyStateProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginTop: theme.spacing(16)
      }}
    >
      <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}>
        {primaryText}
      </Typography>
      {secondaryText && <Typography variant="body1">{secondaryText}</Typography>}
    </Box>
  );
};
